module.exports = "https://trybtryb-legacy.web.app/img/pompelmo.64bc3ad9.webp";